module.exports = __webpack_public_path__ + "static/contents4-eae7e455d2a9776ef1b42cbc49cd8ff5.jpg";